import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from '../config/config';
import { ResponsePackage } from '../models/util.model';
import { EmcOptions, Purpose, SectionDefinitionEntityType } from '../models/dynamic-buildings.model';

@Injectable({
  providedIn: 'root',
})
export class EntityModelCustomizationService {
  private pathApi = this.config.setting['pathApi'] + 'entityModelCustomization/';
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient, private config: AppConfig) {}

  getSelectedEmcOptions(
    entityType: SectionDefinitionEntityType,
    purpose: Purpose,
    utilityId: number
  ): Observable<any> {
    return this.http.get<ResponsePackage<EmcOptions[]>>(
      `${this.pathApi}getSelectedEmcOptions/${entityType}/${purpose}/${utilityId}`,
      { headers: this.headers, observe: 'response' }
    );
  }
}
